(() => {
  const DESKTOP_QUERY = window.matchMedia('(min-width: 1000px)');
  const SELECTOR = '.shopify-section--main-product .product-gallery';

  function createArrow(direction) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `delfi-product-gallery-arrow delfi-product-gallery-arrow--${direction}`;
    button.setAttribute('aria-label', direction === 'prev' ? 'Previous product images' : 'Next product images');
    button.innerHTML = direction === 'prev'
      ? '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10.5 2.5 5 8l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M5.5 2.5 11 8l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return button;
  }

  function enhanceGallery(gallery) {
    if (!gallery || gallery.dataset.delfiEditorialGallery === 'true') return;

    const carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    const controls = document.createElement('div');
    controls.className = 'delfi-product-gallery-controls';

    const prev = createArrow('prev');
    const next = createArrow('next');
    controls.append(prev, next);
    gallery.append(controls);
    gallery.dataset.delfiEditorialGallery = 'true';

    const getStep = () => {
      const firstMedia = carousel.querySelector('.product-gallery__media');
      if (!firstMedia) return carousel.clientWidth / 2;
      const styles = getComputedStyle(carousel);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return firstMedia.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      prev.disabled = carousel.scrollLeft <= 2;
      next.disabled = carousel.scrollLeft >= maxScroll - 2;
      controls.hidden = !DESKTOP_QUERY.matches || maxScroll <= 2;
    };

    prev.addEventListener('click', () => {
      carousel.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      carousel.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    carousel.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });

    requestAnimationFrame(updateButtons);
    setTimeout(updateButtons, 300);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(enhanceGallery);
  }

  document.addEventListener('DOMContentLoaded', init);
  init();

  const observer = new MutationObserver(() => init());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

/* ============================================================
   PRODUCT DESCRIPTION
   Open by default on desktop, closed on mobile
   ============================================================ */

(() => {
  const desktopQuery = window.matchMedia('(min-width: 1000px)');
  const descriptionSelector =
    '.shopify-section--main-product [data-block-type="description"] details';

  function setDescriptionDefault() {
    document.querySelectorAll(descriptionSelector).forEach((details) => {
      if (desktopQuery.matches) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', setDescriptionDefault);
  document.addEventListener('shopify:section:load', setDescriptionDefault);

  desktopQuery.addEventListener('change', setDescriptionDefault);

  setDescriptionDefault();
})();